import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { I18NextModule } from 'angular-i18next';
import i18next from 'i18next';
import { OrderService } from 'src/app/core/services/order.service';
import { FeedbackModalComponent } from 'src/app/shared/components/feedback-modal/feedback-modal.component';
import { PetitionerType } from 'src/app/shared/model/petitionerType.enum';

@Component({
  standalone: true,
  selector: 'app-modal-modify-book-vehicle',
  templateUrl: './modal-modify-book-vehicle.component.html',
  styleUrls: ['./modal-modify-book-vehicle.component.scss'],
  imports: [
    CommonModule,
    I18NextModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatSelectModule
  ]
})
export class ModalModifyBookVehicleComponent {
  petitionerTypeEnum = PetitionerType;
  form: FormGroup = this.fb.group({});
  onlyObservations = false;

  constructor(
    public dialogRef: MatDialogRef<ModalModifyBookVehicleComponent>,
    private fb: FormBuilder,
    private orderService: OrderService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.form = this.fb.group({
      petitionerType: [this.data.booking?.customerType, [Validators.required]],
      name: [this.data.booking?.firstName, [Validators.required]],
      firstSurname: [this.data.booking?.firstLastName, [Validators.required]],
      secondSurname: [this.data.booking?.secondLastName, [Validators.required]],
      phone: [
        this.data.booking?.phone,
        [
          Validators.required,
          Validators.minLength(9),
          Validators.maxLength(9),
          Validators.pattern('^[0-9]*$')
        ]
      ],
      email: [
        this.data.booking?.email,
        [
          Validators.pattern(
            '[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z]{2,4}$'
          ),
          Validators.required
        ]
      ],
      observations: [this.data.booking?.observations]
    });

    if (
      this.data.requestStatus === 'SENT_TO_FACTORY' ||
      this.data.requestStatus === 'IN_PRODUCTION'
    ) {
      this.onlyObservations = true;
    } else {
      this.onlyObservations = false;
    }
  }
  submitRequest() {
    const body = {
      petitionerType: this.form.value.petitionerType,
      name: this.form.value.name,
      firstSurname: this.form.value.firstSurname,
      secondSurname: this.form.value.secondSurname,
      telephone: this.form.value.phone,
      email: this.form.value.email,
      comments: this.form.value.observations
        ? this.form.value.observations
        : null,
      requestNumber: this.data.requestNumber
    };

    this.orderService.bookVehicle(body).subscribe({
      next: () => {
        this.dialog.open(FeedbackModalComponent, {
          data: {
            text: i18next.t('modifyBookOK'),
            close: true,
            theme: 'dark'
          }
        });
        this.dialogRef.close();
      },
      error: () => {
        this.dialog.open(FeedbackModalComponent, {
          data: {
            text: i18next.t('modifyBookKO'),
            close: true,
            theme: 'dark'
          }
        });
      }
    });
  }
}
